import i18n from 'i18n/config';

export const AGGRESSIVE_INTERVAL_THRESHOLD = 3600; // Must match backend AGGRESSIVE_THRESHOLD (1 hour in seconds)
const tt = (key, defaultValue) => i18n.t(key, { defaultValue });
const getT = t => (typeof t === 'function' ? t : i18n.t.bind(i18n));
export const StandardSensors = [
  'Vibration Mote',
  'Vibration Mote (VM1)',
  'Vibration Mote (VM2)',
  'Vibration Mote (VM3)',
  'Vibration Mote (VM4P)',
  'Vibration Mote (GSP)',
  'Vibration Mote (VM4)',
  'Vibration Mote (GS)',
  'Transmitter'
];

export const VectorSensors = [
  'Magnetometer Sensor',
  'Current Sensor',
  'Vibration Sensor',
  'VSX',
  'Ultrasound Vector Sensor'
];

export const GainSettingOptions = [
  { text: 1, value: 1 },
  { text: 2, value: 2 },
  { text: 4, value: 4 },
  { text: 8, value: 8 },
];

export const BiasOptions = [
  { text: '0%', value: 0 },
  { text: '10%', value: 10 },
  { text: '20%', value: 20 },
  { text: '30%', value: 30 },
  { text: '40%', value: 40 },
  { text: '50%', value: 50 },
  { text: '60%', value: 60 },
  { text: '70%', value: 70 },
  { text: '80%', value: 80 },
  { text: '90%', value: 90 },
  { text: '100%', value: 100 },
];

export const getOperatingVoltageOptions = (t) => {
  const tr = getT(t);
  return [
    { text: tr('sensors.constants.operatingVoltage.off', { defaultValue: 'OFF' }), value: 0 },
    { text: '5V', value: 5 },
    { text: '12V', value: 12 },
    { text: '15V', value: 15 },
    { text: '24V', value: 24 },
    { text: '30V', value: 30 },
  ];
};

// Deprecated: prefer getOperatingVoltageOptions(t) so language changes are reflected.
export const OperatingVoltageOptions = getOperatingVoltageOptions();

export const getOutputRangeOptions = (t) => {
  const tr = getT(t);
  return [
    {
      text: tr('sensors.constants.outputRange.voltage', { defaultValue: 'Voltage' }),
      value: 'voltage',
      children: [
        { text: '0-5 V', value: 0 },
        { text: '0-30 V', value: 3 },
      ],
    },
    {
      text: tr('sensors.constants.outputRange.current', { defaultValue: 'Current' }),
      value: 'current',
      children: [
        { text: '4-20 mA', value: 4 },
      ],
    },
  ];
};

export const OutputRangeOptions = getOutputRangeOptions();

export const getSensorSubTypeOptions = (t) => {
  const tr = getT(t);
  return [
    { text: tr('sensors.constants.sensorSubType.voltage', { defaultValue: 'Voltage' }), value: 'voltage' },
    { text: tr('sensors.constants.sensorSubType.current', { defaultValue: 'Current' }), value: 'current' },
  ];
};

export const SensorSubTypeOptions = getSensorSubTypeOptions();

export const getTemperatureSensorSubTypeOptions = (t) => {
  const tr = getT(t);
  return [
    { text: tr('sensors.constants.temperatureSubType.rtd', { defaultValue: 'RTD' }), value: 'rtd' },
    { text: tr('sensors.constants.temperatureSubType.voltage', { defaultValue: 'Voltage' }), value: 'voltage' },
    // { text: 'Thermocouple', value: 'thermocouple' },
  ];
};

export const TemperatureSensorSubTypeOptions = getTemperatureSensorSubTypeOptions();

export const getUltrasoundSensorSubTypeOptions = (t) => {
  const tr = getT(t);
  return [
    // { text: 'Voltage', value: 'voltage' },
    { text: tr('sensors.constants.ultrasoundSubType.current', { defaultValue: 'Current' }), value: 'current' },
  ];
};

export const UltrasoundSensorSubTypeOptions = getUltrasoundSensorSubTypeOptions();

export const getConditionerTypeOptions = (t) => {
  const tr = getT(t);
  return [
    { text: tr('sensors.constants.conditionerType.iepeOrIcp', { defaultValue: 'IEPE or ICP' }), value: 'iepe' },
    { text: '4 - 20 mA', value: '4-20mA' },
    { text: tr('sensors.constants.conditionerType.cableResistance', { defaultValue: 'Cable Resistance' }), value: 'cable_resistance' },
    { text: tr('sensors.constants.conditionerType.na', { defaultValue: 'N/A' }), value: '' },
  ];
};

export const ConditionerTypeOptions = getConditionerTypeOptions();

export const getAxesOptions = (t) => {
  const tr = getT(t);
  return [
    { text: tr('sensors.constants.axes.triaxial', { defaultValue: 'Triaxial' }), value: 3 },
    { text: tr('sensors.constants.axes.singleAxis', { defaultValue: 'Single axis' }), value: 1 },
  ];
};

export const AxesOptions = getAxesOptions();

export const SensorRequiredFields = [
  'name',
  'model_number',
  'units',
  'sensor_type',
  'output_signal_type'
];

export const SensorConfigRequiredFields = {
  default: ['operating_voltage', 'range', 'output_type', 'input_range', 'settling_time'],
  accelerometer: ['default_fmax', 'default_lor'],
  current: ['rl', 'te'],
  temperature: ['sub_type', 'r0'],
  pressure: ['sub_type']
};

export const ErrorMessages = {
  wifi_ssid_required: 'Wi-Fi SSID is required',
  wifi_password_required: 'Wi-Fi Password is required',
  wifi_schedule_in_past: 'Reconfiguration time must be in the future',
  temperature_only_location_assigned: 'Temperature-only mode cannot be changed while mote is assigned to a location',
  invalid_bssid: 'Entered BSSID is invalid ( should be a 12 digit hexadecimal mac address )',
  bssid_required: 'BSSID is required',
  invalid_channel: 'Entered Channel is invalid ( should be a number between 1 and 13 )',
  channel_required: 'Channel is required'
};

export const reservedPrefixes = ['VM', 'TX', 'VSX'];

export const getReservedPrefixesErrorMessage = (t, prefixes = reservedPrefixes) => {
  const tr = getT(t);
  return tr('sensors.errors.serialNumberReservedPrefix', {
    defaultValue: 'Serial number cannot start with a Petasense reserved keyword - {{prefixes}}',
    prefixes: prefixes.join(', ')
  });
};

export const MESSAGE = {
  // Deprecated: prefer getReservedPrefixesErrorMessage(t).
  serialNumberError: getReservedPrefixesErrorMessage()
};


export const vibrationMeasurementTypeEnum = {
  overall: '0',
  fullBandwidth: '1',
  highRes: '2',
};

/**
 * Pairs each vibration measurement type with the field it is stored under on a
 * sensor detail, in payload order.
 *
 * A device only reports the measurement types its model supports — the backend
 * skips any type with no channel row — so EVERY entry here must be treated as
 * optional by callers. Reading `details.high_res.x` or descending an
 * immutability-helper spec into an absent block throws.
 */
export const vibrationMeasurementBlocks = [
  { index: vibrationMeasurementTypeEnum.overall, field: 'overall' },
  { index: vibrationMeasurementTypeEnum.fullBandwidth, field: 'full_bandwidth' },
  { index: vibrationMeasurementTypeEnum.highRes, field: 'high_res' }
];

export const sensorChannelOrientations = {
  accelerometer: {
    0: 'x',
    1: 'y',
    2: 'z'
  },
  current: {
    0: 'r',
    1: 'y',
    2: 'b'
  }
};

export const oldTxMeasurementVersion = [
  'v1'
];

export const defaultSensorsPageColumns = [
  'serial_number',
  'machine',
  'location',
  'battery_level',
  'wifi_signal',
  'last_reported_at',
];

export const allSensorsPageColumns = [
  'serial_number',
  'machine',
  'location',
  'battery_level',
  'wifi_signal',
  'last_reported_at',
  'last_measurement_time',
  'firmware'
];

export const CHART_TYPES_FOR_VM3 = [
  { value: 'Battery Voltage', text: 'Battery Voltage' },
  { value: 'Coulomb Count', text: 'Coulomb Count' },
  { value: 'Wifi RSSI Level', text: 'Wifi RSSI Level' }
];

export const CHART_TYPES = [
  { value: 'Battery Voltage', text: 'Battery Voltage' },
  { value: 'Wifi RSSI Level', text: 'Wifi RSSI Level' },
  { value: 'Measurement Cycle Time', text: 'Measurement Cycle Time' },
  { value: 'Wifi Connect Time', text: 'Wifi Connect Time' },
  { value: 'Data Exchange Time', text: 'Data Exchange Time' }
];

export const RI_FIRMWARE_VERSION_ULIMIT = {
  MAJOR_VERSION: 'R41',
  MINOR_VERSION: '19'
};

export const SAMPLING_LIMIT = 20000; // for simultaneous measurement
export const FMAX_LOR_CONVERSION_FACTOR = 2.56;
